// Shared state and helpers for the magazine scripts. Every other file in js/magazine/
// hangs its pieces off `mag`; the only true globals are the functions Blazor calls by
// name through JS interop (see boot.js, calculators.js, media.js, maps.js, fingerprint.js).

var mag = window.mag || {};
window.mag = mag;

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

// Below this width the articles stack vertically: the `sm` breakpoint in _mixin.scss, as
// the same media query, so script and stylesheet always agree on the layout.
mag.MOBILE_QUERY = '(max-width: 767px)';
mag.DESKTOP_QUERY = '(min-width: 768px)';
mag.REDUCE_QUERY = '(prefers-reduced-motion: reduce)';
mag.isMobile = () => window.matchMedia(mag.MOBILE_QUERY).matches;

mag.reduceMotion = () => window.matchMedia(mag.REDUCE_QUERY).matches;

// Vertical scroll to an absolute page offset. Used by the stacked mobile layout; the
// desktop strip is scrolled through its ScrollTrigger in scroller.js.
mag.scrollToY = (y, duration) => {
    gsap.to(window, { scrollTo: y, duration: duration / 1000, ease: 'power1.inOut', overwrite: 'auto' });
};

// Page offset of an element's top edge, like jQuery's .offset().top
mag.pageTop = (el) => el.getBoundingClientRect().top + window.scrollY;

// A scope collects what a piece of the magazine sets up — listeners (via `signal`),
// observers, timers and other cleanup — so it can all be undone in one call. The visit
// (one run of startBrochure) is a scope, and so is each layout inside it: switching from
// desktop to mobile tears the desktop scope down and builds the mobile one.
mag.scope = (parent) => {
    const controller = new AbortController();
    const scope = {
        signal: controller.signal,
        observers: [],
        timers: [],
        cleanups: [],
        observe: (observer) => {
            scope.observers.push(observer);
            return observer;
        },
        onEnd: (fn) => scope.cleanups.push(fn),
        end: () => {
            if (controller.signal.aborted) {
                return;
            }
            controller.abort();
            scope.observers.forEach(o => o.disconnect());
            scope.timers.forEach(id => clearTimeout(id));
            scope.cleanups.splice(0).reverse().forEach(fn => fn());
        },
    };
    parent?.signal.addEventListener('abort', scope.end);
    return scope;
};

// Everything one run of startBrochure() sets up, so a second run (Blazor navigates back to
// /browse within the same circuit) can tear the first one down instead of stacking on it.
mag.session = null;

mag.startSession = () => {
    mag.endSession();
    const session = mag.session = mag.scope();
    session.media = gsap.matchMedia();
    return session;
};

mag.endSession = () => {
    const session = mag.session;
    if (!session) {
        return;
    }
    session.media.revert();
    session.end();
    ScrollTrigger.getAll().forEach(t => t.kill());
    Draggable.get('.drag-proxy')?.kill();
    gsap.killTweensOf(window);
    mag.session = null;
};
